import resolveExif from 'exif-normalizer';

window.picaResize = function (file, maxWidth, maxHeight, quality, callback) {
    const pica = require('pica')();

    if (typeof quality === 'undefined') {
        quality = 0.90;
    }

    const img = new Image;
    const _URL = (window).URL || (window).webkitURL;
    img.src = _URL.createObjectURL(file);
    img.onload = function () {
        // rotate the image based on EXIF data
        resolveExif(img).then(function (imageUrl) {
            const rotatedImg = new Image;
            rotatedImg.src = imageUrl;
            rotatedImg.onload = function () {
                // rotated full-sized image
                const sourceCanvas = window.picaResizeImgToCanvas(rotatedImg);

                // smaller canvas to resize the larger image onto
                var resizedCanvas = document.createElement('canvas');
                var resizedCtx = sourceCanvas.getContext('2d');

                if (rotatedImg.width / rotatedImg.height > maxWidth / maxHeight) {
                    // width is the greater constraint
                    resizedCanvas.width = maxWidth;
                    resizedCanvas.height = Math.round(maxHeight * (rotatedImg.height/rotatedImg.width));
                } else {
                    // height is the greater constraint
                    resizedCanvas.width = Math.round(maxWidth * (rotatedImg.width/rotatedImg.height));
                    resizedCanvas.height = maxHeight;
                }

                pica.resize(sourceCanvas, resizedCanvas)
                    .then(result => pica.toBlob(result, 'image/jpeg', quality))
                    .then(function (blob) {
                        var reader = new (window).FileReader();
                        var thumbnail;

                        // convert from blob to data URL
                        reader.readAsDataURL(blob);
                        reader.onloadend = function() {
                            thumbnail = reader.result;
                            if (callback != null) {
                                callback(thumbnail, resizedCanvas);
                            }
                        }
                    });
            };
        });
    };
};

window.picaResizeImgToCanvas = function (img) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    return canvas;
};
